import { render } from "preact";
import "./lib/render/fonts.css";
import "./styles/app.css";
import { App } from "./App";

render(<App />, document.getElementById("app")!);

if (import.meta.env.PROD && "serviceWorker" in navigator) addEventListener("load", () => navigator.serviceWorker.register("/sw.js"));
